/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { overrideForwardRef } from "../OverridableComponent";

import "./ListItem.scss";

export interface IListItemProps {
	children?: React.ReactNode;
	className?: string;
}

export const ListItem = overrideForwardRef<IListItemProps, "li">(
	({ children, className, Component, ...props }, ref) => {
		const baseClass = BEM("edt-list-item");

		if (className) {
			baseClass.add(className);
		}

		return (
			<Component {...props} className={baseClass.toClassName()} ref={ref}>
				<div className={baseClass.element("content").toClassName()}>{children}</div>
			</Component>
		);
	}
);

ListItem.defaultProps = {
	Component: "li"
};
